import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { TabMenu } from 'primereact/tabmenu';
import OperateriTab from './componentsTabs/OperateriTab';
import MobilniOperateriTab from './componentsTabs/MobilniOperateriTab';
import MobilnaLogovanjaTab from './componentsTabs/MobilnaLogovanjaTab';
import MobilnaPravaTab from './componentsTabs/MobilnaPravaTab';
import './settings.css';

const Access_config = () => {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);
  const items = [
    { label: t('admin.tabOperateri') },
    { label: t('admin.tabMobilniOperateri') },
    { label: t('admin.tabPrijaveTelefon') },
    { label: t('admin.tabMobilnaPrava') },
  ];

  return (
    <div className="config_workspace">
      <div id="config_tabs">
        <TabMenu id="accessConfigTabs" activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} style={{ marginBottom: '0' }} model={items} />
        {activeIndex === 0 && <OperateriTab />}
        {activeIndex === 1 && <MobilniOperateriTab />}
        {activeIndex === 2 && <MobilnaLogovanjaTab />}
        {activeIndex === 3 && <MobilnaPravaTab />}
      </div>
    </div>
  );
};

export default Access_config;
